import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8592 17.1042C10.8592 16.5296 10.5211 16.2423 9.84507 16.2423H8.07042V7.08169C8.07042 6.74366 7.97465 6.47887 7.7831 6.28732C7.59155 6.09577 7.33803 6 7.02254 6C6.71831 6 6.39718 6.10141 6.05916 6.30423L3.43944 7.92676C3.14648 8.10704 3 8.36056 3 8.68732C3 8.93521 3.07887 9.16056 3.23662 9.36338C3.40563 9.5662 3.60845 9.66761 3.84507 9.66761C3.96901 9.66761 4.10986 9.62253 4.26761 9.53239L5.89014 8.53521V16.2423H4.13239C3.44507 16.2423 3.10141 16.5296 3.10141 17.1042C3.10141 17.7014 3.44507 18 4.13239 18H9.84507C10.5211 18 10.8592 17.7014 10.8592 17.1042ZM20 17.2083C20 16.9954 19.9127 16.8056 19.738 16.6389L17.5988 14.4306L19.6071 12.3472C19.7817 12.1806 19.869 11.9907 19.869 11.7778C19.869 11.5648 19.7866 11.3843 19.6216 11.2361C19.4664 11.0787 19.2772 11 19.0541 11C18.8212 11 18.6126 11.0926 18.4283 11.2778L16.4927 13.3056L14.5572 11.2778C14.3728 11.0926 14.1642 11 13.9314 11C13.7179 11 13.5288 11.0787 13.3638 11.2361C13.1989 11.3843 13.1164 11.5648 13.1164 11.7778C13.1164 11.9907 13.2037 12.1806 13.3784 12.3472L15.3867 14.4306L13.262 16.6389C13.0873 16.8056 13 16.9954 13 17.2083C13 17.412 13.0825 17.5926 13.2474 17.75C13.4123 17.9074 13.6015 17.9861 13.815 17.9861C14.0478 17.9861 14.2564 17.8935 14.4407 17.7083L16.4927 15.5417L18.5447 17.7083C18.7193 17.9028 18.9279 18 19.1705 18C19.3936 18 19.5877 17.9213 19.7526 17.7639C19.9175 17.5972 20 17.412 20 17.2083Z"
        fill="currentColor"
      />
    </svg>
  );
});
export const ElementSpeedIcon1x = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
